<script setup lang="ts">
import { Enums } from "@/enums";
import type { Spec } from "../types";

const props = defineProps<{
    specs: Spec[];
}>();
</script>

<template>
    <div class="w-full overflow-x-auto">
        <table class="rns-items-table">
            <thead>
                <tr>
                    <th>Penggunaan</th>
                    <th>Nama</th>
                    <th>Jumlah</th>
                    <th>Catatan</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="spec in props.specs">
                    <tr>
                        <td class="w-1/6">{{ Enums.ProvisionSpecStatusEnum.label(spec.status) }}</td>
                        <td class="w-2/6">{{ spec.name }}</td>
                        <td class="w-1/6">{{ spec.quantity }}</td>
                        <td class="w-2/6">{{ spec.notes ?? "-" }}</td>
                    </tr>
                    <tr v-for="taken in spec.items">
                        <td colspan="4">
                            <span class="font-bold">({{ taken.quantity }}x)</span>
                            {{ taken.name }} {{ taken.code }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-items-table {
    @apply w-full;
}

.rns-items-table th {
    @apply text-white bg-black py-2;
}

.rns-items-table td {
    @apply border p-2 text-center;
}
</style>
